import React from 'react';
import './Services.css';
import animationEntreprise from "../../assets/images/entreprise2.png";
import animationFestival from "../../assets/images/festival3.png";
import { Card, CardContent } from "../../components/ui/Card/Card";

const Services = () => {
	React.useEffect(() => {
		document.documentElement.style.setProperty("--animation-entreprise", `url(${animationEntreprise})`);
		document.documentElement.style.setProperty("--animation-festival", `url(${animationFestival})`);
	}, []);
	
  return (
      <section id="services">
        <h2>Mes Services</h2>
        <div className="card-container">
		<Card className="card animation-entreprise">
            <CardContent>
              <h3>Animation en entreprise</h3>
              <p>
                Dynamisez vos équipes avec des sessions de jeu sur mesure, adaptées à vos objectifs.
              </p>
            </CardContent>
          </Card>
          <Card className="card animation-stands">
            <CardContent>
              <h3>Animation de stands</h3>
              <p>
                Rehaussez l’expérience de vos visiteurs grâce à une animation professionnelle et engageante.
              </p>
            </CardContent>
          </Card>
        </div>
      </section>
  );
};

export default Services;